import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import config from '@/config'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: config.isMagenta ? '#e20074' : '#6e32a0',
        secondary: '#f2f2f2',
        warning: !config.isMagenta ? '#e37501' : undefined
      }
    }
  },

  icons: {
    iconfont: 'mdi'
  }
})
